import { render, staticRenderFns } from "./OfficersPage.vue?vue&type=template&id=48d65af1&scoped=true&"
import script from "./OfficersPage.vue?vue&type=script&lang=js&"
export * from "./OfficersPage.vue?vue&type=script&lang=js&"
import style0 from "./OfficersPage.vue?vue&type=style&index=0&id=48d65af1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d65af1",
  null
  
)

export default component.exports